module.exports = __webpack_public_path__ + "media/images/yt-f7f0a0b1857ba592e1b4f7c6265b150d.svg";